import React from 'react'
import { Image } from 'semantic-ui-react'
import ShowReviews from '../components/ShowReviews'
import ShowServices from '../components/ShowServices'
import FreeEstimate from '../components/FreeEstimate'

export default function Home() {
  return (
    <>
      <div style={{ textAlign: 'center' }}>
        <h1 className="mt-4 pt-0 mb-4">
          Complete Tree Removal and Trimming Services
        </h1>
        <h2 className="mt-0 pt-0 mb-2">Residential and Commercial</h2>
        <h3 className="mt-0 pt-0 mb-5">
          Customer satisfaction is one of our highest priorities.
        </h3>
        <Image
          src="/images/clark-trees-smiley.jpg"
          style={{ margin: '0 auto' }}
        />
      </div>
      <ShowServices />
      <ShowReviews showCount={3} />
      <FreeEstimate />
    </>
  )
}
